import { geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';

// this function translates google maps address components into our data shape for addresses
// https://developers.google.com/maps/documentation/geocoding/intro#Types
// we combine "street_number" and "route" to make shipping_street_address_1
// ["locality", "political"] or ["sublocality", "political"] is city
// ["administrative_area_level_1", "political"] is state/province

export const translateAddressFromComponents = (addressComponents, placeId) => {
  const defaultAddressComponent = {
    short_name: ''
  };

  const streetNumber =
    addressComponents.find(component =>
      component.types.includes('street_number')
    ) || defaultAddressComponent;

  const route =
    addressComponents.find(component => component.types.includes('route')) ||
    defaultAddressComponent;

  const city =
    addressComponents.find(
      component =>
        (component.types.includes('locality') ||
          component.types.includes('sublocality') ||
          component.types.includes('administrative_area_level_3')) &&
        component.types.includes('political')
    ) || defaultAddressComponent;

  const state =
    addressComponents.find(
      component =>
        component.types.includes('administrative_area_level_1') &&
        component.types.includes('political')
    ) || defaultAddressComponent;

  const postalCode =
    addressComponents.find(component =>
      component.types.includes('postal_code')
    ) || defaultAddressComponent;

  const country =
    addressComponents.find(component => component.types.includes('country')) ||
    defaultAddressComponent;

  return {
    shipping_street_address_1: `${streetNumber.short_name} ${route.short_name}`,
    shipping_city: city.short_name,
    shipping_state: state.short_name,
    shipping_country: country.short_name,
    shipping_postal_code: postalCode.short_name,
    shipping_google_place_id: placeId
  };
};

/**
 * Get the geocoded suggestion and longitude, latitude for a given address
 */
export const geocodePlaceId = async placeId => {
  const geocodedSuggestions = await geocodeByPlaceId(placeId);
  const mostProbable = geocodedSuggestions[0];
  const latLng = await getLatLng(mostProbable);
  return { latLng, geocodedSuggestion: mostProbable };
};

export const getAddressStringFromCart = cart =>
  cart.shipping_street_address_1
    ? `${cart.shipping_street_address_1}, ${cart.shipping_city}, ${cart.shipping_state}`
    : '';
